import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { pb } from '@/core/api';
import { useAuthStore } from '@/stores/auth';
import { invalidateAccessCache } from '@/core/access-check';
import { useToast } from '@/components/ui/toast';

type StartResponse = {
  success: boolean;
  redemption_ends_at: string;
  threshold: number;
};

// Fase 28 (28.6.1): kick off the 24h Redemption Day window. On success we
// invalidate the access cache + refreshAuth() synchronously so the UI flips
// to /redemption immediately (otherwise React Query's 30s staleTime would
// leave the user staring at the Game Over page until the next poll tick).
export function useStartRedemption() {
  const qc = useQueryClient();
  const nav = useNavigate();
  const { toast } = useToast();
  const refreshAuth = useAuthStore((s) => s.refreshAuth);
  return useMutation({
    mutationFn: () =>
      pb.send<StartResponse>('/api/team-members/redemption/start', {
        method: 'POST',
      }),
    onSuccess: async () => {
      invalidateAccessCache();
      await refreshAuth();
      qc.invalidateQueries({ queryKey: ['collector-summary'] });
      nav('/redemption', { replace: true });
    },
    onError: () => toast('No se pudo iniciar la redención', 'error'),
  });
}
